import Money from "./Money";

export default class PresentmentPrice {
  price?: Money;
  compareAtPrice?: Money;

  constructor(response?: any) {
    if (response != null) {
      this.price = new Money(response.price);
      this.compareAtPrice = new Money(response.compareAtPrice);
    }
  }
}
